import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import { LocalBrowserStorage } from '../core/_services/local-browser.storage';
import { environment } from '../../environments/environment';

const MICROSOFT_TOKEN_URL = `${environment.apiPrefix}/power-bi/token`;
const pullOutToken = (data) => data.access_token;

@Injectable()
export class PowerbiTokenService {
  static PowerBiTokenName = 'power_bi_token';
  private token: string = null;

  constructor(private http: HttpClient, private storage: LocalBrowserStorage) {
    const token = this.storage.getItem(PowerbiTokenService.PowerBiTokenName);
    if (token) this.token = token;
  }

  private saveTokenToStorage = (token) => {
    if (!token) return;
    this.storage.setItem(PowerbiTokenService.PowerBiTokenName, token);
  };

  requestToGetToken() {
    return this.http
      .get(MICROSOFT_TOKEN_URL)
      .pipe(
        map(pullOutToken),
        catchError(() => of(null)),
        tap(this.saveTokenToStorage),
      )
      .toPromise();
  }

  get microsoftToken() {
    return this.token;
  }
}
